import React from "react";
import PropTypes from "prop-types";
import analyticsService, {
  ANALYTICS_TYPES,
} from "@common/services/analyticsService";

class ProfileDropdownToggle extends React.Component {
  state = {};

  handleClick = (e) => {
    e.preventDefault();
    this.props.onClick(e);
    analyticsService.track(ANALYTICS_TYPES.OPEN_MENU, {
      Menu: "Profile Menu",
      Screen: this.props.currentPath,
    });
  };

  render() {
    return <div onClick={this.handleClick}>{this.props.children}</div>;
  }
}

ProfileDropdownToggle.propTypes = {
  currentPath: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.object,
};

export default ProfileDropdownToggle;
